module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1010-7f95839012db35ee24df5e31146925cd.png";